import { useEffect, useMemo, useState } from "react";

import Header from "./Header";
import Map from './Map';

import { useAtom } from "jotai";
import { selectedEntityAtom, poisAtom } from "./State";
import { useLocation, useNavigate } from "react-router-dom";
import { ChargingType, Entity, Parcel } from "@the-real-insight/tri-model";
import { useTranslation } from 'react-i18next';
import { useCustomerTheme } from "./Theme";

interface MapViewProps {
    resource: any;
    resetResource?: () => void;
}

export default function MapView(properties: MapViewProps) {
    const { t } = useTranslation();
    const { theme } = useCustomerTheme();
    const [, setObjectPanelExpanded] = useState(false);
    const [pois, setPoIs] = useAtom(poisAtom);
    const [_selectedEntity, setSelectedEntity] = useAtom(selectedEntityAtom) as any;
    const [entityHistory, setEntityHistory] = useState([]) as any;
    const [_entityHistoryIndex, setEntityHistoryIndex] = useState(0) as any;
    // const [mapQuery] = useAtom(mapQueryAtom);
    // const [mapData] = useAtom(mapDataAtom);
    // const [mapOptions] = useAtom(mapOptionsAtom) as any;
    const { search } = useLocation();
    const _navigate = useNavigate();
    const searchParams = useMemo(() => new URLSearchParams(search), [search]);
    const [mapData, setMapData] = useState(null) as any;
    const [mapQuery, setMapQuery] = useState(null) as any;
    const [mapOptions, setMapOptions] = useState(null) as any;

    useEffect(() => {
        console.log('======> resource for MapView', properties.resource);

        setMapData(properties.resource.data);
        setMapQuery(properties.resource.query);
        // Ensure options is always an object, never null or undefined
        setMapOptions(properties.resource.options || {});
    }, [properties.resource]);

    const selectEntity = (entity: any, changeHistory: boolean = true) => {
        console.log('Set entity >>>', entity);
        setSelectedEntity(entity);

        if (changeHistory) {
            setEntityHistory([...entityHistory, entity]);
            setEntityHistoryIndex(entityHistory.length);
        }

        searchParams.set("selectedEntityType", entity.entityType || entity.class);
        searchParams.set("selectedEntity", entity._id);
        //navigate(`/map?${searchParams.toString()}`)

        if (entity) {
            setObjectPanelExpanded(true);
        }
    }

    const _poisChanged = (pois: any[]) => {
        console.log('POIs changed >>>', pois);

        setPoIs(pois);
    }

    const _propertiesTitle = (entity: any) => {
        if (!entity) {
            return <></>;
        }

        const typeName = entity.getTypeName ? (entity as Entity).getTypeName() : entity.class;

        switch (typeName) {
            case 'Building': return <div></div>;
            case 'ChargingStation': return <div>
                <div>
                    <div className="textM">{entity.chargingType === ChargingType.normalCharging ? t('ui.chargingStation') : t('ui.fastChargingStation')}</div>
                </div>
                <div>
                    <div className="headerXL">{entity.operator}</div>
                </div>
            </div>;
            case 'Billboard': return <div>
                <div>
                    <div className="textM">Anzeigetafel</div>
                </div>
                <div>
                    <div className="headerXL">{entity.operator || 'Unbekannter Betreiber'}</div>
                </div>
            </div>;
            case 'AdvertisementColumn': return <div>
                <div>
                    <div className="textM">Litfaßsäule</div>
                </div>
                <div>
                    <div className="headerXL">{entity.operator || 'Unbekannter Betreiber'}</div>
                </div>
            </div>;
            case 'University': return <div>
                <div>
                    <div className="textM">Universität</div>
                </div>
                <div>
                    <div className="headerXL">{entity.name}</div>
                </div>
            </div>;
            case 'Area': return <div><div>
                <div className="textM">Gebiet</div>
            </div>
                <div>
                    <div className="headerXL">{entity && entity.id ? `${entity.id}` : ''}</div>
                </div>
            </div>;
            case 'Parcel': return <div>
                <div>
                    <div className="textM">Flurstück {(entity as Parcel).parcelID} ({(entity as Parcel).getLandUseName()})</div>
                </div>
                <div>
                    <div className="headerXL">{(entity as Parcel).name || 'Unbenannt'}</div>
                </div>
            </div>
            case 'Bridge':
            case 'Tile':
            case 'LocalGovernment':
            case 'PostalCode':
            case 'PlotOfLand':
            case 'Way':
            case 'Shape':
            case 'PoI':
            default: {
                const typeLabel = (entity.getTypeClass && entity.getTypeClass()) 
                    ? entity.getTypeClass().type.label.de 
                    : (entity.class || 'Objekt');
                
                return <div>
                    <div className="textM">{typeLabel}</div>
                    <div className="headerXL">{entity && (entity as any).name ? (entity as any).name : 'Unbenannt'}</div>
                </div>
            }
        }
    }

    return (
        <div className="width100vw height100vh displayFlex flexDirectionColumn">
            <Header showHome={true} homeClicked={() => properties.resetResource?.()} title={mapOptions && mapOptions.title ? mapOptions.title : ''}></Header>
            <div className="flex1 displayFlex paddingM gapM" style={{ backgroundColor: theme.primaryLighter }}>
                <div className="flex1">
                    {mapData && mapOptions && mapQuery && <Map setObject={selectEntity} options={mapOptions} showMiniMap={true} data={mapData} objectClass={mapQuery ? (mapQuery as any).objectClass : null} pois={pois} query={mapQuery} />}
                </div>
            </div>
        </div>
    );
}
